import { defineMessages } from "react-intl";

export const messages = defineMessages({
  seeError: {
    defaultMessage: "See error log",
    description: "see error log label in notification"
  },
  hideError: {
    defaultMessage: "Hide log",
    description: "hide error log label in notification"
  }
});

export const Manifest = {
  sourceError: (nameSource: string) =>
    nameSource === "Eordering" ? `Error \n` : `Error ${nameSource} \n`
};
